import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=6967b36b&"
import script from "./ColorInput.vue?vue&type=script&lang=js&"
export * from "./ColorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6967b36b')) {
      api.createRecord('6967b36b', component.options)
    } else {
      api.reload('6967b36b', component.options)
    }
    module.hot.accept("./ColorInput.vue?vue&type=template&id=6967b36b&", function () {
      api.rerender('6967b36b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ColorInput.vue"
export default component.exports